<template>
    <div>
        <label v-if="multiple">
            <input 
                type="checkbox" 
                v-model="allSelected"
                />Select All</label>
        <vue-select
            ref="select" 
            :multiple="multiple" 
            v-bind="$attrs"
            v-on="$listeners"
            @input="showVal($event)"
            :value="value">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
            <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
        </vue-select>
    </div>
</template>

<script>
import vSelect from "vue-select";
export default {
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        value: null
    },
    watch: {
        value(val){
            // this.$emit('input',val)
        }
    },
    methods:{
        showVal(v){
            this.$emit('input',v)
        },
        selectAll() {
            const select = this.$refs.select;
            let map_function = (v) => { return v } 
            if(this.$attrs.reduce){
                map_function = this.$attrs.reduce
            }
            console.log(select.options.map(map_function))
            
            this.$emit('input', select.options.map(map_function))
            
            // bug caused by onAfterSelect
            select.open = false
        }
    },
    computed: {
        allSelected:{
            get(){
                if(this.multiple){
                    let map_function = (v) => { return v } 
                    if(this.$attrs.reduce){
                        map_function = this.$attrs.reduce
                    }
                    try {
                        return this.$attrs.options
                        .map(map_function)
                        .every(o => this.value.some(v => v == o))
                    } catch(e) {
                        console.warn(e)
                        return false
                    }

                } else {
                    return false
                }
            },
            set(v){
                console.log(v)
                if(v){
                    this.selectAll()
                } else {
                    this.$emit('input',[])
                }
            }
        }
    },
    components: {
        "vue-select": vSelect
    },
    // props{
    //     : 
    // }
}
</script> 